import { useCallback } from 'react';

import { useConvertContext } from '../../../contexts/ConvertContext';

import { type ConvertGoalKeys } from './convertGoalKeys';
import { PAGE } from '../../../helpers/pages';

type ConvertLeadTrackingProps = {
  page: PAGE;
};

const useConvertLeadTracking = (props: ConvertLeadTrackingProps) => {
  const { page } = props;

  const { sdkContext } = useConvertContext({ page });

  const trackLead = useCallback(
    (goalKey: ConvertGoalKeys) => {
      if (sdkContext) {
        sdkContext.trackConversion(goalKey, {
          ruleData: {
            action: 'sent',
          },
        });
      }
    },
    [sdkContext],
  );

  return { trackLead };
};

export { useConvertLeadTracking };
